import React from "react";
import { observer } from "mobx-react-lite";
import { TailwindModal } from "../../../components";
import { classNames, useStore } from "../../../helpers";
import { VoterCard } from "../../../features/manage-voters/Voters";
import { Radio, RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export const ScannedProfile = observer(() => {
  const { aiGentoolStore, voterListStore } = useStore();
  const { show_scanned_voter, scanned_voters } = aiGentoolStore;
  const { activeVoter } = voterListStore;
  const {t} = useTranslation("fetchFromFacialRecognition")

  const handleSelect = (val) => {
    voterListStore.update_active_voter(val);
  };

  const handleAddVoter = () => {
    if (!activeVoter || Object.keys(activeVoter).length === 0) return;
    console.log("Prefill with voter:", activeVoter);
    aiGentoolStore.update_show_scanned_voter(false);
    aiGentoolStore.toggle_image_capture_modal(false);
    aiGentoolStore.show_voter_not_found(false);
    aiGentoolStore.toggle_image_match_modal(false);
  };

  const handleScanAgain = () => {
    aiGentoolStore.show_voter_not_found(false);
    aiGentoolStore.toggle_image_capture_modal(true);
  };

  return (
    <TailwindModal isOpen={show_scanned_voter}>
      <div className="bg-common-white rounded-2xl p-6 h-[85vh] overflow-auto">
        <div className="bg-grey-100 flex flex-col items-center justify-center p-4 rounded-2xl">
          <div className="flex justify-between items-center bg-gray-150 border border-purple-300 rounded-xl p-4 mb-6 w-full">
            <p className="text-gray-700 font-medium">
              {t("voter_face_matched")}
            </p>
            <div className="flex items-center gap-x-4">
              <button
                className="px-6 py-2 rounded-lg border border-purple-500 text-purple-600 font-medium
                  transition-all duration-300 hover:bg-gradient-to-r hover:from-purple-600 hover:to-blue-500 hover:text-white disabled:opacity-50"
                onClick={handleAddVoter}
                disabled={!activeVoter || Object.keys(activeVoter).length === 0}
              >
                {t("add_this_voter")}
              </button>
              <button
                onClick={handleScanAgain}
                className="text-purple-600 underline cursor-pointer hover:text-purple-800"
              >
                {t("scan_again")}
              </button>
            </div>
          </div>
          <RadioGroup
            value={activeVoter}
            onChange={handleSelect}
            className="w-full"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
              {scanned_voters?.map((voter, index) => (
                <Radio
                  key={voter.id || index}
                  value={voter}
                  aria-label={voter.profile?.name_eng || "Voter"}
                  className="focus:outline-none"
                >
                  {({ checked }) => (
                    <div
                      className={classNames(
                        checked
                          ? "border-4 border-blue-500 rounded-3xl"
                          : "border border-gray-300 rounded-3xl",
                        "transition duration-300 ease-in-out w-full h-full",
                      )}
                    >
                      <VoterCard voterdata={voter} />
                    </div>
                  )}
                </Radio>
              ))}
            </div>
          </RadioGroup>
        </div>
      </div>
    </TailwindModal>
  );
});
